import data from "../../../../../src/drafts/Tooltip/Tooltip.docs.json";
import * as React from 'react';
export default {
  data,
  React
};